import React from "react";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { SkyDialog } from "@skypointcloud/skypoint-ui";
import { clearTokens } from "../../store/slices/authSlice";
import { logger } from "../../logger-init";
import { authService } from "../../utils/authService";
import { hasPhoneSession } from "../../utils/phoneSession";

interface ErrorPageProps {
  show: boolean;
  message?: string;
  errorCode?: string;
  title?: string;
}

const ErrorPage = ({ show, message, errorCode, title }: ErrorPageProps): React.ReactElement => {
  const { instance } = useMsal();
  const dispatch = useDispatch();

  const backToLogin = (): void => {
    dispatch(clearTokens());
    if (hasPhoneSession()) {
      // Signed in by phone: no Microsoft session; back to the sign-in page.
      void authService.logout();
      return;
    }
    instance.logoutRedirect().catch((error) => {
      logger.error("Logout failed:", error instanceof Error ? error : undefined);
    });
  };

  return (
    <SkyDialog
      open={show}
      onOpenChange={() => {}}
      title={title || "Error occurs!"}
      primaryAction={{ label: "Go to Login", onClick: backToLogin }}
    >
      <div className="flex flex-col gap-3">
        {errorCode && <b className="text-red-500">Error Code: {errorCode}</b>}
        <div>
          <b>Message</b>
          <p>{message}</p>
        </div>
      </div>
    </SkyDialog>
  );
};

export default ErrorPage;
